<style scoped>
.beian {
  color: #fff;
  text-decoration: none;
}
.footer-wrap {
  width: 100%;
  background-color: #262d3b;
  overflow: hidden;
}
.footer-wrap .footer-bottom {
  width: 1181px;
  margin: 0 auto;
}
.more {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  /* width: 1200px; */
  align-items: center;
  margin-top: 52px;
  /* justify-content: center; */
  cursor: pointer;
  color: #afafaf;
}
.more img {
  /* margin-left: -180px; */
}
.more .items {
  margin-left: 110px;
  /* margin-right: 100px; */
  width: 744px;
}
.items .more-item {
  font-size: 20px;
  width: 112px;
  text-align: center;
  height: 20px;
  line-height: 20px;
  padding: 0 20px;
  /* padding-right: 99px; */
  border-right: 2px solid #afafaf;
}
.items .more-item:last-child {
  border: 0;
}
.copy {
  color: #fff;
  display: flex;
  justify-content: center;
}
.icp {
  margin-top: 46px;
  font-size: 15px;
}
.icp-number {
  margin: 13px 0 25px 0;
  font-size: 14px;
}
.icp-number img {
  margin-right: 8px;
}
.Copyright {
  margin-right: 6px;
}
.ewm {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
}
.ewm img {
  position: absolute;
}
.ewm-img {
  top: 27px;
  left: 5px;
}
.wbo {
  left: 46px;
}
</style>

<template>
  <div class="footer-wrap">
    <div class="footer-bottom">
      <div class="more">
        <img :src="logoUrl" />
        <div class="items">
          <span
            class="more-item"
            v-for="(item, index) in moreItem"
            :key="index"
            @click="spanClicked(item, index)"
            >{{ item }}</span
          >
        </div>

        <div
          class="ewm"
          @mouseenter="wchatImgHover"
          @mouseleave="wchatImgHover"
        >
          <img :src="wchatImgShow ? contactImgs[0] : contactImgs[3]" alt="" />
          <img :src="ewmImgs[0]" alt="" class="ewm-img" v-if="wchatImgShow" />
        </div>
        <div
          class="ewm"
          @mouseenter="wboImgHover(true)"
          @mouseleave="wboImgHover(false)"
        >
          <img
            :src="wboImgShow ? contactImgs[2] : contactImgs[1]"
            alt=""
            class="wbo"
          />
          <img :src="ewmImgs[1]" alt="" class="ewm-img" v-if="wboImgShow" />
        </div>
      </div>
      <div class="copy icp">
        <span class="Copyright">Copyright</span>©米阳科技.ALL Rrights
        Reserved.<a class="beian" href="https://beian.miit.gov.cn/"
          >浙ICP备{{ beian.icp }}</a
        >
      </div>
      <div class="copy icp-number">
        <img :src="jhUrl" alt="" />
        <div class="">
          <a
            class="beian"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502001696"
            >浙公网安备 33010502001696号</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import communicate from "../../../communicate";
const beians = [
  {
    url: "meyoung.cn",
    icp: "11029185号-2",
    ga: "33010502001696",
  },
  {
    url: "myspzh.com",
    icp: "14032378号-2",
    ga: "33010502001696",
  },
  {
    url: "me56.cn",
    icp: "11029185号-72",
    ga: "33010502001696",
  },
];
function getBeianInfo() {
  const beian = beians.find((item) => {
    return window.location.host.includes(item.url);
  });
  if (!beian) {
    return beians[0];
  }
  return beian;
}
export default {
  name: "cfooter",
  data() {
    const beian = getBeianInfo();
    return {
      beian,
      moreItem: ["走进米阳", "战略合作", "新闻/动态", "友情链接", "站点地图"],
      logoUrl: require("../../../assets/image/footer/logofooter.png"),
      jhUrl: require("../../../assets/image/footer/footer_jh@2x.png"),
      contactImgs: [
        require("../../../assets/image/footer/footer_wchat@2x.png"),
        require("../../../assets/image/footer/footer_wbo@2x.png"),
        require("../../../assets/image/footer/footer_wbo_light@2x.png"),
        require("../../../assets/image/footer/footer_gray_wchat@2x.png"),
      ],
      ewmImgs: [
        require("../../../assets/image/footer/footer_wxewm.png"),
        require("../../../assets/image/footer/footer_wboewm.png"),
      ],
      wchatImgShow: true,
      wboImgShow: false,
    };
  },
  methods: {
    wchatImgHover() {},
    wboImgHover(flag) {
      this.wboImgShow = flag;
      this.wchatImgShow = !flag;
    },
    spanClicked(item, index) {
      console.log("底部：", index);
      var bottomIndex = index;
      if (index == 0) {
        this.$router.push({ name: "about" });
      } else if (index == 1) {
        this.$router.push({ name: "cooperation" });
      } else if (index == 2) {
        this.$router.push({ name: "news_list" });
      } else if (index == 3) {
        this.$router.push({ name: "link" });
        bottomIndex = 3;
      } else {
        this.$router.push({ name: "contact" });
      }
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      communicate.$emit("navItemChange", bottomIndex);
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/page/common/CFooter.vue